<div class="captcha">
  <!-- 图片区域 -->
  <div
    class="captcha-image"
    [style.width.px]="width"
    [style.height.px]="height"
  >
    <!-- 带缺口的背景图 -->
    <img
      class="captcha-bg"
      [src]="imageBase64"
      [style.width.px]="width"
      [style.height.px]="height"
      draggable="false"
    />

    <!-- 拼图滑块层 -->
    <div
      class="captcha-tile"
      [class.is-dragging]="dragging"
      [style.width.px]="tileW"
      [style.height.px]="tileH"
      [style.top.px]="tileY"
      [style.transform]="'translateX(' + tileX + 'px)'"
    >
      <img
        [src]="tileBase64"
        [style.width.px]="tileW"
        [style.height.px]="tileH"
        draggable="false"
      />
    </div>
  </div>

  <!-- 滑动条 -->
  <div
    class="captcha-bar"
    [style.width.px]="width"
  >
    <div
      class="captcha-track"
      #sliderTrack
      (mousedown)="onMouseDown($event)"
      (touchstart)="onTouchStart($event)"
    >
      <!-- 已滑动区域 -->
      <div
        class="captcha-fill"
        [style.width.px]="tileX + tileW / 2"
      ></div>

      <!-- 拖动把手 -->
      <div
        class="captcha-thumb"
        [class.is-dragging]="dragging"
        [style.left.px]="thumbLeft"
      >
        <svg viewBox="0 0 24 24" class="captcha-thumb-icon">
          <path d="M8 5v14l-4-4 4-4m8-6v14l4-4-4-4" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>

      <!-- 提示文字 -->
      <span class="captcha-hint" *ngIf="tileX === 0 && !dragging">
        按住滑块，拖动到缺口处
      </span>
    </div>
  </div>
</div>
